import axios from 'axios'
import router from '../router/index'
import {getToken} from "./auth";
import {removeToken} from './auth';
import {Message} from 'element-ui'
const service = axios.create({
    // baseURL: 'http://localhost:8076', // 商城api 的 base_url
    baseURL: 'https://pay.yunka-it.cn', // 商城api 的 base_url
    //  baseURL: 'http://localhost:8075', // 商城api 的 base_url
    // baseURL: 'http://hardware.it.iyyclub.com', // 商城api 的 base_url
    // baseURL: 'https://api.dr-coffee.cn', // 商城api 的 base_url
    // baseURL: 'http://121.43.166.130:8071', //企业注册的base_url
    timeout: 1000000, // request timeout
})

service.interceptors.request.use(
    config => {
        let url = config.url,
            token = getToken();
        if (token && url.indexOf('token') < 0) {
            if (url.indexOf('?') < 0) {
                url = url + `?token=${token}`;
            } else {
                url = url + `&token=${token}`;
            }
        }
        config.url = url;

        return config
    },
    error => {
        console.log(error)
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
       if (response.headers["content-type"].indexOf("json") !==-1){
           if (response.status == 200) {
               if (response.data.code == 18) {
                   removeToken();
                   router.push({path: '/login'})
                   return
               }
               response.data.code = parseInt(response.data.code, 10)
               if (parseInt(response.data.code) != 0) {
                   Message.error(response.data.msg)
                   return Promise.reject()
               }
           }
           return response.data
       }
       return response

    },
    error => {
        console.log('err' + error)
        Message.error('网络异常')
        return Promise.reject(error)
    }
)

export default service
